<fcp-modal title="{{ title }}" [id]="id" [size]="size">
    <div class="fc-download-selection-modal" fcp-modal-content>
        <div class="fc-download-selection-modal-section">
            <div class="fc-download-selection-modal-toggle-row">
                <div class="fc-download-selection-modal-toggle">
                    <fcp-toggle-switch
                        [ngModel]="selection.images"
                        [ngModelOptions]="{ standalone: true }"
                        (onChange)="onImagesToggleChange($event.checked)"
                    ></fcp-toggle-switch>
                    <span class="fc-download-selection-modal-toggle-label fcp-text-body-m">{{
                        'DOWNLOAD_CONTENT_MODAL.TOGGLE_IMAGES' | translate
                    }}</span>
                    <fcp-icon
                        cdkOverlayOrigin
                        #infoIcon="cdkOverlayOrigin"
                        class="fc-download-selection-modal-toggle-icon fcp-text-body-l"
                        [icon]="['fal', 'circle-info']"
                        (mouseenter)="showTooltip(true)"
                        (mouseleave)="showTooltip(false)"
                    ></fcp-icon>
                    <fcp-tooltip
                        [open]="isTooltipVisible"
                        [overlayOrigin]="infoIcon"
                        [customPosition]="tooltipPosition"
                    >
                        {{ 'DOWNLOAD_CONTENT_MODAL.TOOLTIP_TEXT' | translate }}
                    </fcp-tooltip>
                </div>
                <fcp-badge
                    *ngIf="showImageCountBadge"
                    class="fc-download-selection-modal-count-badge"
                    size="small"
                    color="neutral"
                    [inversed]="true"
                    [text]="downloadMetadata.imageCount.toString()"
                ></fcp-badge>
            </div>
            <div class="fc-download-selection-modal-multi-choice" *ngIf="selection.images">
                <div class="fc-download-selection-modal-subheading fcp-text-body-m">
                    {{ 'DOWNLOAD_CONTENT_MODAL.IMAGE_SIZE' | translate }}
                </div>
                <div
                    *ngFor="let resolutionOption of resolutionOptions"
                    class="fc-download-selection-modal-multi-choice-item"
                >
                    <fcp-radiobutton
                        [inputId]="'download-modal-resolution-' + resolutionOption.value"
                        name="selectedResolution"
                        [value]="resolutionOption.value"
                        [ngModel]="selection.resolution"
                        [ngModelOptions]="{ standalone: true }"
                        [label]="resolutionOption.text | translate"
                        (ngModelChange)="onResolutionSelected($event)"
                    ></fcp-radiobutton>
                </div>
            </div>
        </div>

        <div
            class="fc-download-selection-modal-section fc-download-selection-modal-section-compact"
            *ngIf="videoDownloadEnabled()"
        >
            <div class="fc-download-selection-modal-toggle-row">
                <div class="fc-download-selection-modal-toggle">
                    <fcp-toggle-switch
                        [ngModel]="selection.video"
                        (onChange)="onVideosToggleChange($event.checked)"
                    ></fcp-toggle-switch>
                    <span class="fc-download-selection-modal-toggle-label fcp-text-body-m">{{
                        'DOWNLOAD_CONTENT_MODAL.TOGGLE_VIDEOS' | translate
                    }}</span>
                </div>
                <fcp-badge
                    *ngIf="showVideoCountBadge"
                    class="fc-download-selection-modal-count-badge"
                    size="small"
                    color="neutral"
                    [inversed]="true"
                    [text]="downloadMetadata.videoCount.toString()"
                ></fcp-badge>
            </div>
        </div>

        <div class="fc-download-selection-modal-section">
            <div class="fc-download-selection-modal-toggle">
                <fcp-toggle-switch
                    [ngModel]="selection.productAttributes"
                    (onChange)="onProductAttributesToggleChange($event.checked)"
                ></fcp-toggle-switch>
                <span class="fc-download-selection-modal-toggle-label fcp-text-body-m">{{
                    'DOWNLOAD_CONTENT_MODAL.TOGGLE_DATA_ATTRIBUTES' | translate
                }}</span>
            </div>
            <div class="fc-download-selection-modal-multi-choice" *ngIf="selection.productAttributes">
                <div class="fc-download-selection-modal-subheading fcp-text-body-m">
                    {{ 'DOWNLOAD_CONTENT_MODAL.LANGUAGE' | translate }}
                </div>
                <div
                    *ngFor="let csvLanguageOption of csvLanguageOptions"
                    class="fc-download-selection-modal-multi-choice-item"
                >
                    <fcp-radiobutton
                        [inputId]="'download-modal-csv-' + csvLanguageOption.value"
                        name="selectedCsvLanguage"
                        [value]="csvLanguageOption.value"
                        [ngModel]="selection.csvLanguage"
                        [ngModelOptions]="{ standalone: true }"
                        [label]="csvLanguageOption.text | translate"
                        (ngModelChange)="onCsvLanguageSelected($event)"
                    ></fcp-radiobutton>
                </div>
            </div>
        </div>
    </div>
    <div fcp-modal-actions class="fcp-modal-actions fc-download-selection-modal-actions">
        <button fcp-outlined-button (click)="closeModal()">
            {{ 'TEXT_CANCEL' | translate }}
        </button>
        <button fcp-button color="prominent" [disabled]="isDownloadDisabled" (click)="downloadContent()">
            <fcp-icon [icon]="['fal', 'download']"></fcp-icon>
            {{ 'DOWNLOAD_CONTENT_MODAL.DOWNLOAD_BUTTON' | translate }}
        </button>
    </div>
</fcp-modal>
